import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import ActivityListComponent from '../components/classactivity/list/list.jsx';
import {closeActivityListModal,openActivityDetailModal} from "../redux/actions/modelsActive";
import {getActivityListRequest} from "../service/activity";

import defaultImg from "../img/bee.png";


class ActivityListContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'handleImageErrored',
            'getActivityList',
            'activityDetail'
        ]);
        this.state = {

            activityList: [

            ]
        }

    }


    componentDidMount() {
        this.getActivityList();

    }

    activityDetail(code){

        sessionStorage.setItem('huodongcode',code)
        this.props.openActivityDetailModal();
    }


    handleImageErrored(index){

        var list = this.state.studentList;
        list[index].img = defaultImg;

        this.setState({
            studentList:list,
        });
    }

    getActivityList(){
        getActivityListRequest( (data) => {
            console.log(data)
            if(data.ret=='1'){
                this.setState({
                    activityList:data.data
                });
            }
        });
    }

    render() {

        return (
            <ActivityListComponent
                onRequestClose={this.props.closeActivityListModal}
                activityList={this.state.activityList}
                handleImageErrored={this.handleImageErrored}
                activityDetail={this.activityDetail}
            />
        )
    }


}

ActivityListContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeActivityListModal: () => dispatch(closeActivityListModal()),
        openActivityDetailModal: () => dispatch(openActivityDetailModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivityListContainer);
